<template>
  <div>


    <d-row class="mt-2">
      <d-col class="col-lg-12">
        <v-feedback :bus="bus"></v-feedback>
      </d-col>
    </d-row>

    <v-delete-dialog
      v-if="showingDeleteAlert"
      @close="showingDeleteAlert = false"
      @confirm="onRemoveOrder"
      @cancel="cancelDelete"
      :errorMessage="errorMessage">
    </v-delete-dialog>

    <d-row>
      <div class="col-lg-8">
        <d-card-body title="Average Ratings" :subtitle="'# of reviews: ' + reviews.length"  >

        </d-card-body>
      </div>
      <div class="col-lg-4">
        <thead vertical v-for="(item, i) in average" :key="i" >
          <tr>
            <th scope="col">{{ item.name }}</th>
            <th scope="col"></th>
            
            <th scope="col">
              <span v-for="n in 5" :key="n" class="star" v-bind:class="{'full-star': n <= Math.ceil(item.rating / 20), 'half-star': n > item.rating / 20 && n < Math.ceil(item.rating / 20), 'empty-star': n > Math.ceil(item.rating / 20)}">&#9733;</span>

            </th>
          </tr>
        </thead>
      </div>

    </d-row>
    <d-row class="mt-4">
      <div class="col-lg-6 mb-3">
            <d-input class="col-12" name='searchField' type="text" v-model="search" placeholder="filter reviews by content or name"></d-input>
          </div>
    </d-row>
    <d-row lg="12" v-if="reviews.length > 0" >
      <d-col class="col-lg-12">
        <d-card>
         <d-card-body class="p-0">
            <div class="table-responsive">
              <table class="table mb-0">
                <thead class="bg-light">
                <tr class="border-0 col-12">
                  <th scope="col" class="border-0 col-2"><span>Name</span></th>
                  <th scope="col" class="border-0 col-4"><span>Content</span></th>
                  <th scope="col" class="border-0 col-2"><span>Language</span></th>
                  <th scope="col" class="border-0 col-2"><span>Ratings</span></th>
                  <th scope="col" class="border-0 col-2"><span>Created at</span></th>
                  <th scope="col" class="border-0 col-2"><span>Delete</span></th>
                </tr>
                </thead>
                <tbody>
                  <tr class="col-12" v-for="(r, i) in getPage" :key="i">
                    <td class="col-2">
                      {{ r.name }}
                    </td>
                    <td class="col-4">
                      {{ r.content }}
                    </td>
                    <td class="col-2">
                      {{ r.language }}
                    </td>
                    <td class="col-2">
                      <div v-for="(rating, j) in r.ratings" :key="j">
                          <span :id="'rating'+j+i"> 
                            <span v-for="n in 5" :key="n" class="star" v-bind:class="{'full-star': n <= Math.ceil(rating.rating / 20), 'half-star': n > rating.rating / 20 && n < Math.ceil(rating.rating / 20), 'empty-star': n > Math.ceil(rating.rating / 20)}">&#9733;</span>
                          </span>
                          <d-tooltip :target="'#rating'+j+i">
                              {{rating.name}}
                          </d-tooltip>
                      </div>
                    </td>

                    <td class="col-2">
                      {{ new Date(r.created_at ).toLocaleString('en-US', { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit' }) }}
                    </td>
                    <td class="col-2">
                      
                      <div v-on:click="confirmDelete(r.id)" class="d-flex">
                        <i class="fa fa-trash align-self-center" style="width: 20px"></i>
                      </div>

                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </d-card-body>

          <v-pagination
            v-on:goToPage="goToPage($event)"
            ref="pagination"
            :totalItems="filteredReviewList.length"
            :activePage="currentPage"
            :totalPage="totalPage">
          </v-pagination>
        </d-card>
      </d-col>
    </d-row>
    <d-card v-else>
      No reviews found for this provider
    </d-card>

    <d-row v-else>
      <div class="col-lg-12">
        <div scope="col" class="border-0 col-6"><d-card-body title="No review found for this provider"/></div> 
      </div>
      
    </d-row>

  </div>

</template>


<script>
	import Vue from "vue";


	export default {
    
		name: "Reviews",


    methods:{
      goToPage: function (id) {
        this.currentPage = id
        this.getPage;
    },
      onRemoveOrder: async function(id ) {

        if (this.reviewIDToBeRemoved == ''){
          this.showingDeleteAlert = false;
          this.bus.$emit('submitData', {type: 'warning', message: 'Error: ' + this.errors[0].message})
          return
        }


        this.showingDeleteAlert = false;

        const variables = {
          id: this.reviewIDToBeRemoved
        };

        try {
          const data = await this.$apollo.query({
            query: require('../../../graphql/reviews/DeleteReview.gql'), variables, fetchPolicy: 'no-cache'
          }).then(data => {
            if (data.data.deleteReview.success) {
              this.bus.$emit('submitData', {type: 'success', message: 'Review has been succesfully removed!'})
              removeItem(this.reviewIDToBeRemoved)
            }else{
              this.bus.$emit('submitData', {type: 'warning', message: 'Review has not been removed!'})

            }
          })
        } catch (error) {
          // Todo: show feedback
          this.bus.$emit('submitData', {type: 'warning', message: 'Error: ' + this.errors[0].message})
        }
      },

      cancelDelete() {
        this.showingDeleteAlert = false;
        this.reviewIDToBeRemoved = ''

      },

      confirmDelete: function(id) {
        this.showingDeleteAlert = true;
        this.reviewIDToBeRemoved = id
      },

      removeItem(id) {
      const index = this.reviews.findIndex(item => item.id === id);
      if (index !== -1) {
        console.log(index);
        this.reviews.splice(index, 1);
        
      }
    }

    },
    computed: {
      filteredReviewList() {
      return this.reviews.filter(item => {
       
          this.currentPage = 1
          //this.$refs.pagination.resetPage()
          return item.name.toLowerCase().includes(this.search.toLowerCase()) || item.content.toLowerCase().includes(this.search.toLowerCase());
       
      })
    },
      getPage() {
        return this.filteredReviewList.slice((this.currentPage - 1) * this.totalPage, this.currentPage * this.totalPage);
      },
  },
    apollo: {
      load: function () {
        return {
          fetchPolicy: 'no-cache',
          variables: {
            id: this.$route.params.id,
          },
          update: function (data) {
            this.reviewResults = data.provider.reviewResults;
            this.average = this.reviewResults.average
            this.average.slice().sort((a, b) => a.name.localeCompare(b.name))
            this.reviews = this.reviewResults.reviews
            
          },
          query: require('../../../graphql/GetProviderReviews.gql'),
        };
      },

    },
    data: function () {
      reviews : null
      
      return{
        reviewResults : null,
        average:null,
        reviews:[],
        showingDeleteAlert:false,
        errorMessage:'Do you really want to remove this review',
        reviewIDToBeRemoved: '',
        bus: new Vue(),
        search: '', 
        currentPage: 1,
        totalPage: 25,

      }

    },
	}


</script>


<style>

.main-container {
  display: flex;
  width: 100%;

}
.half-container{
  width: 40%;
}

.rating-item {
  display: flex;
  width: 100%;
}

.rating {
  display: flex; /* Aligns the stars and name in a row */
  width: 50%;
}

.star {
  color: gold; /* Color for active stars */
  cursor: pointer; /* Changes cursor to pointer to indicate clickability */
}

.full-star {
  /* No additional styling needed here; could add if needed for full stars */
}

.half-star::after {
  content: '\\2605'; /* Unicode character for black (empty) star, shown for half */
  position: absolute;
  width: 50%;
  overflow: hidden;
  color: gray; /* Color for half-filled stars */
}

.empty-star {
  color: gray; /* Color for inactive stars */
}
</style>